module.exports = __webpack_public_path__ + "static/media/bush.5a71345e.png";